<template>
  <div class="kuaikanauth">
    <div class="member_auth">
      <img src="../img/member_auth.png" alt />
    </div>
    <div class="auth_item" v-for="(item, index) in auth_item" :key="index">
      <div class="auth_title">
        <img :src="item.title" alt />
      </div>
      <div class="topic_list">
        <div
          class="topic_item"
          v-for="(topic, topic_index) in item.topic"
          :key="topic_index"
          @click="jumpToTopic(topic)"
        >
          <div class="topic_cover">
            <img :src="topic.v_cover" alt />
            <div class="topic_tag" v-show="topic.tag != ''">
              <div class="topic_tag_inner">{{ topic.tag }}</div>
            </div>
          </div>
          <div class="topic_title">{{ topic.title }}</div>
          <div class="topic_desc">{{ topic.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { miniprogramNav } from "@/assets/fe_js/common/miniprogram/utils";
// api
import { detail } from "../api/detail.api";

const { log } = console;
export default {
  data() {
    return {
      auth_item: [
        {
          title: require("../img/auth_title_1.png"),
          name: "会员新作",
          topic: [
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
          ],
        },
        {
          title: require("../img/auth_title_2.png"),
          name: "会员专享",
          topic: [
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
          ],
        },
        {
          title: require("../img/auth_title_3.png"),
          name: "付费畅销",
          topic: [
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
            {
              cover: "",
              title: "",
              desc: "",
              tag: "",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState(["activity_name_topic", "pool_name", "xdevice"]),
  },
  mounted: function () {
    this.getTopic();
  },
  methods: {
    // 处理接口返回非200
    handleResErr(res) {
      log(res);
      this.$showToast(res.message);
    },
    // 获取作品
    getTopic() {
      let data = {
        activity_name: this.activity_name_topic,
        pool_name: "",
      };
      let headers = {
        "X-Device": this.xdevice,
      };
      detail({
        data,
        headers,
      })
        .then((res) => {
          res = this.$formatAxiosRes(res);
          log("获取作品成功--", res);
          ![200].includes(res.code) && this.handleResErr(res);
          [200].includes(res.code) &&
            this.handleTopic(res.data.candidate_pools);
        })
        .catch((err) => {
          log("获取作品错误--", err);
        });
    },

    // 处理作品
    handleTopic(data) {
      let topic_obj = {};
      data.forEach((item, index) => {
        topic_obj[item.pool_title] = this.createTopicItem(item.candidate_items);
      });
      this.auth_item = [];

      this.auth_item = this.auth_item.concat(
        {
          title: require("../img/auth_title_1.png"),
          name: "会员新作",
          topic: topic_obj["会员新作"],
        },
        {
          title: require("../img/auth_title_2.png"),
          name: "会员专享",
          topic: topic_obj["会员专享"],
        },
        {
          title: require("../img/auth_title_3.png"),
          name: "付费畅销",
          topic: topic_obj["付费畅销"],
        }
      );
    },
    // 处理作品项目
    createTopicItem(list) {
      const arr = [];
      list.forEach((item, index) => {
        if (index < 6) {
          arr.push({
            v_cover: this.$jointImageSuffix({
              src: item.vertical_image_url,
              width: 207,
            }),
            tag:
              item.words_info.comic_mark_text != undefined
                ? item.words_info.comic_mark_text
                : "",
            title: item.candidate_title,
            desc:
              item.words_info.topic_discount != undefined
                ? item.words_info.topic_discount
                : "",
            id: item.other_id,
          });
        }
      });
      return arr;
    },
    // 是否在小程序中
    isMiniProgram() {
      let is_mini = {
        wechatmini: window.__gvalkkmh.ua.wechatmini,
        qqmini: window.__gvalkkmh.ua.qqmini,
        baidumini: window.__gvalkkmh.ua.baidumini,
      };
      return is_mini;
    },
    // 跳转作品详情页
    jumpToTopic(item) {
      this.$doTrack({ name: "点击封面", TopicName: item.title });

      if (this.$kkmh.ua().kkmh) {
        this.$kkmh.requestHybrid({
          schema: "kkaction",
          tagname: "loadTopicDetail",
          param: {
            id: item.id,
          },
          callback(res) {
            cb && cb(res);
          },
        });
      } else {
        let page = `/pages/topic/topic?id=${item.id}`;
        if (
          this.isMiniProgram()["wechatmini"] ||
          this.isMiniProgram()["qqmini"] ||
          this.isMiniProgram()["baidumini"]
        ) {
          miniprogramNav(page);
        } else {
          log("端外跳转");
          location.href = `https://m.kuaikanmanhua.com/mobile/${item.id}/list/`;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/common.scss";
.kuaikanauth {
  width: trans(670);
  margin: 0 auto;
  margin-top: trans(20);
  margin-bottom: trans(54);
}
.member_auth {
  @include boxsize(670, 348);
  @include layout(center, center);
  background-color: #fbfaff;
  border-radius: trans(20);
  img {
    @include boxsize(627, 296);
    display: block;
  }
}
.auth_item {
  margin-top: trans(50);
  margin-bottom: trans(-36);
  .auth_title {
    @include boxsize(575, 80);
    margin: 0 auto;
    img {
      @include boxsize(575, 80);
      display: block;
    }
  }
  .topic_list {
    @include layout(space-between, flex-start);
    width: trans(650);
    margin: 0 auto;
    margin-top: trans(40);
    .topic_item {
      margin-bottom: trans(36);
      .topic_cover {
        @include boxsize(200, 265);
        // background-color: #000;
        border-radius: trans(20);
        position: relative;
        overflow: hidden;
        img {
          @include boxsize(200, 265);
          display: block;
        }
      }
      .topic_tag {
        // @include boxsize(140, 36);
        @include bgimg("../img/tag_bg.png", 100%, 100%);
        position: absolute;
        top: 0;
        left: 0;
        .topic_tag_inner {
          @include textellipsis();
          @include fontstyle(#fff4d2, 22);
          width: trans(146);
          line-height: trans(36);
          text-align: center;
          max-width: trans(146);
        }
      }
      .topic_title {
        @include fontstyle(#422222, 28);
        @include textellipsis();
        max-width: trans(200);
        font-weight: bold;
        line-height: 1.15;
        margin-top: trans(14);
      }
      .topic_desc {
        @include fontstyle(#9e8c8a, 22);
        @include textellipsis();
        max-width: trans(200);
        line-height: 1.15;
        margin-top: trans(7);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/comp/KuaikanAuth.vue